import { useTran } from 'src/i18n/useTran'
import { useTheme } from 'src/ui/style/useTheme'
import { FooterColumn } from 'src/layout/footer/FooterColumn'
import { View } from 'src/ui/basic/View'
import { Text } from 'src/ui/basic/Text'
import { grid, verticalChildSpacing } from 'src/ui/style/mixins/layout'
import { Image } from 'src/ui/img/Image'
import footerAssets from 'src/layout/footer/assets'
import React, { ComponentType } from 'react'
import { css } from 'src/ui/style/css'
import { msg } from 'src/i18n/texts/keys'
import { ExternalLink } from 'src/routing/ui/ExternalLink'
import { appStores } from 'src/business/contact/contactInfo'
import { Theme } from 'src/ui/style/Theme'
import { alternateTexts } from 'src/seo/altNames'
import { useLangSource } from '../../business/static-pages/content/useStaticPageTrans'
import { getAppContext } from '../../context/AppContext'
import { Country } from '../../api/defs/enums.type'

const MobileAppButton: ComponentType<{ link: string; image: string }> = ({
    link,
    image
}) => (
    <ExternalLink
        value={link}
        css={css`
            // To have exact height and width as image (children)
            display: flex;
            width: 10em;
        `}
    >
        <Image
            alt={alternateTexts.DownloadApp}
            src={image}
            width={160}
            height={53}
        />
    </ExternalLink>
)

export const titleStyle = () => (th: Theme) => css`
    text-transform: uppercase;
    font-weight: ${th.fontWeight.bold};
`

export const iOS = () => {
    return (
        [
            'iPad Simulator',
            'iPhone Simulator',
            'iPod Simulator',
            'iPad',
            'iPhone',
            'iPod'
        ].includes(navigator.platform) ||
        (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
    )
}

export const AppCardColumn = () => {
    const t = useTran()
    const th = useTheme()
    const country = getAppContext().config.boxylandCountry
    const AppStore = useLangSource(footerAssets.appStore)
    const GooglePlay = useLangSource(footerAssets.googlePlay)

    return (
        <FooterColumn>
            {/* Override of FooterColumn spacing since this one has 2 parts */}
            <View css={verticalChildSpacing(th.spacing.lg)}>
                <View css={verticalChildSpacing(th.spacing.sm)}>
                    <Text css={titleStyle()}>
                        {t(msg.ui.footer.appCardColumn.appTitle)}
                    </Text>
                    <MobileAppButton
                        link={appStores.appStore}
                        image={AppStore}
                    />
                    {!iOS() && (
                        <MobileAppButton
                            link={appStores.googlePlay}
                            image={GooglePlay}
                        />
                    )}
                </View>
                <View
                    css={[
                        verticalChildSpacing(th.spacing.sm)(th),
                        css`
                            min-width: 13em;
                        `
                    ]}
                >
                    <Text css={titleStyle()}>
                        {t(msg.ui.footer.appCardColumn.cardTitle)}
                    </Text>
                    <View
                        css={[
                            grid({
                                minWidth: '2.5em',
                                gap: '0.25em',
                                auto: 'fill'
                            }),
                            css`
                                align-items: flex-end;
                            `
                        ]}
                    >
                        {Object.values(
                            country === Country.HUN ||
                                country === Country.ROU ||
                                country === Country.ITA ||
                                country === Country.DEU
                                ? footerAssets.paymentHu
                                : footerAssets.payment
                        ).map((gp, i) => (
                            <Image
                                key={i}
                                alt={alternateTexts.PaymentCard}
                                src={gp}
                                width={49}
                                height={30}
                            />
                        ))}
                    </View>
                </View>
            </View>
        </FooterColumn>
    )
}
